export interface Site {
  id: string;
  name: string;
  code: string;
}
